import React, { } from 'react'
import { useTranslation } from 'react-i18next'
import { FormButton } from './profile.styled'
import { Button, Form, Input } from 'antd'

const passwordRule = /^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).*$/
function ResetPasswordForm (props) {
  const { canCancel, handleCancel, handleModPass, resetMode } = props
  const { t: ln_t } = useTranslation()
  const [form] = Form.useForm()

  const defPlaceholder = (name, type) => {
    const message = type === 'input' ? ln_t('util.pleaseEnter') : type === 'select' ? ln_t('util.pelaseSelect') : ''
    return `${message} ${ln_t(`profile.${name}`)}`
  }
  const defConfig = (name, type, required = true) => ({ name, label: ln_t(`profile.${name}`), rules: [{ required, message: defPlaceholder(name, type) }] })

  const validation = {
    password: [{ required: true, message: defPlaceholder('newPassword', 'input') },
      { pattern: passwordRule, message: ln_t('message.error.matchPassPattern') }],
    confirmPassword: [{ required: true, message: defPlaceholder('confirmPassword', 'input') }]
  }

  return (
    <Form form={form} layout="vertical" requiredMark={false} onFinish={e => handleModPass(e)} style={{ marginTop: '20px' }}>
      {resetMode
        ? ''
        : <Form.Item {...defConfig('oldPassword', 'input')}>
            <Input.Password placeholder={defPlaceholder('oldPassword', 'input')} />
          </Form.Item>
      }
      <Form.Item {...defConfig('newPassword', 'input')}
        rules={[...validation.password, ({ getFieldValue }) => ({
          validator (rule, value) {
            if (!value || getFieldValue('oldPassword') !== value) return Promise.resolve()
            return Promise.reject(ln_t('message.error.newPassSameAsOld'))
          }
        })]}
      >
        <Input.Password placeholder={defPlaceholder('newPassword', 'input')}/>
      </Form.Item>
      <Form.Item {...defConfig('confirmPassword', 'input')}
          rules={[...validation.confirmPassword, ({ getFieldValue }) => ({
            validator (rule, value) {
              if (!value || getFieldValue('newPassword') === value) return Promise.resolve()
              return Promise.reject(ln_t('message.error.passIsNotSameWithNew'))
            }
          })]}
      >
        <Input.Password placeholder={defPlaceholder('confirmPassword', 'input')}/>
      </Form.Item>
      <div style={{ color: 'rgba(0,0,0,.4)', padding: '0px 4px' }}>
        <div>{ln_t('user.password.length')}</div>
        <div>{ln_t('user.password.format')}</div>
      </div>
      <FormButton style={{ justifyContent: 'center', marginTop: '16px' }}>
        {canCancel ? <Button type="default" onClick={handleCancel}>{ln_t('util.cancel')}</Button> : ''}
        <Button type="primary" htmlType="submit">{ln_t('util.confirm')}</Button>
      </FormButton>
    </Form>
  )
}

export default ResetPasswordForm
